import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { SiteConfigurationType } from '@dynamika-shared/types/site';
import { EditSmallIcon, TrashIcon } from '@dynamika-shared/ui/icons';
import { getValueWithTooltip } from '@dynamika-shared/ui/Table/getValueWithTooltip';

type SiteColumnsType = {
  onSiteClick: (
    site: SiteConfigurationType,
    procedure: 'edit' | 'delete'
  ) => void;
};

const loading = () => (
  <div className='h-2 w-10 animate-pulse rounded-md bg-brightGray'></div>
);

const LENGTH_FOR_TOOLTIP = 10;

export const makeSiteColumns = (
  props: SiteColumnsType
): ColumnType<SiteConfigurationType>[] => {
  return [
    {
      name: 'code',
      header: () => 'Site Code',
      loading,
      getValue: getValueWithTooltip('code', LENGTH_FOR_TOOLTIP),
      hasSorting: true,
      thClassName: 'max-w-[13.6%] min-w-[8rem] w-[13.6%]',
      headerClassName: 'whitespace-nowrap',
    },
    {
      name: 'principalInvestigator',
      header: () => 'Principal Investigator',
      loading,
      getValue: getValueWithTooltip(
        'principalInvestigator',
        LENGTH_FOR_TOOLTIP
      ),
      thClassName: 'max-w-[19.8%] min-w-[19.8%] w-[19.8%]',
      headerClassName: 'whitespace-nowrap',
    },
    {
      name: 'imagingFacilities',
      header: () => 'Facility Name(s)',
      loading,
      getValue: row => {
        const text = row.imagingFacilities.map(r => r.name).join('; ');
        return getValueWithTooltip(
          'principalInvestigator',
          LENGTH_FOR_TOOLTIP
        )({ principalInvestigator: text });
      },
      thClassName: 'max-w-[46%] min-w-[46%] w-[46%]',
      headerClassName: 'whitespace-nowrap',
    },
    {
      name: 'imagingFacilities',
      header: () => 'Nr of users',
      loading,
      getValue: () => {
        return 'n/a';
      },
      thClassName: 'max-w-[9rem] min-w-[9rem] w-[9rem]',
      headerClassName: 'whitespace-nowrap',
    },
    {
      name: 'actions',
      header: () => 'Action',
      loading,
      getValue(row) {
        return (
          <div className='flex justify-end gap-1'>
            <EditSmallIcon
              className='cursor-pointer hover:text-dodgerBlue'
              width={24}
              height={24}
              onClick={() => props.onSiteClick(row, 'edit')}
              data-testid={`editSiteButton-${row.id}`}
            />
            <TrashIcon
              className='cursor-pointer hover:text-dodgerBlue'
              width={24}
              height={24}
              onClick={() => props.onSiteClick(row, 'delete')}
              data-testid={`deleteSiteButton-${row.id}`}
            />
          </div>
        );
      },
      alignToRight: true,
    },
  ];
};
